<template>
    <div class="tasks" :class="{loading: loading}">
        <form accept-charset="UTF-8"
              novalidate="novalidate"
              class="form-group"
              @submit.prevent="search"
              data-vv-scope="task">

            <div class="row">
                <div class="form-group col-sm-6 col-lg-4">
                    <label for="search" class="display-block">Search</label>

                    <div class="input-group">
                        <input id="search" name="q" type="text" class="form-control" v-model="q">

                        <span class="input-group-btn">
                            <button type="submit" class=" btn btn-primary btn-block">
                                <i aria-hidden="true" class="fa fa-search"></i>
                            </button>
                        </span>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-4 form-group">
                    <label for="task-taskable-type">Type</label>
                    <select id="task-taskable-type"
                            v-model="taskable_type"
                            name="taskable_type"
                            class="form-control">
                        <option value="">-</option>
                        <option v-for="taskableType in taskableTypes"
                                :value="taskableType.value">
                            {{taskableType.label}}
                        </option>
                    </select>
                </div>

                <div class="col-sm-6 col-lg-4 form-group">
                    <label>Filters</label>

                    <div class="multi-select-filter">
                        <multi-select v-model="filters" :options="filterOptions"/>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 col-md-4 form-group has-feedback" :class="{'has-error': errors.has('project_id')}"
                     v-if="showProperties">
                    <label for="project-id">Project</label>

                    <select id="project-id"
                            v-model="project_id"
                            name="project_id"
                            class="form-control"
                            v-validate="'required'"
                            aria-required="true"
                            required="true">
                        <option value="">-</option>
                        <option v-for="property in properties" :value="property.project_id">
                            {{property.name}}
                        </option>
                    </select>

                    <span v-show="errors.has('project_id')" class="help-block">
                        {{ errors.first('project_id') }}
                    </span>
                </div>
            </div>

            <div class="form-group">
                <a href="javascript://void(0)" class="btn btn-xs btn-default" @click="resetFilters">
                    <i aria-hidden="true" class="fa fa-refresh"></i> Reset Filters
                </a>
            </div>
        </form>

        <div class="row">
            <div class="col-xs-8">
                <pagination v-model="tasksMeta.current_page" :total-page="tasksMeta.last_page"/>
            </div>
            <div class="col-xs-4 text-right">
                <span class="query-count">Count: {{tasksMeta.total}}</span>
            </div>
        </div>

        <table class="table table-responsive table-striped table-hover">
            <thead>
            <tr>
                <th class="display-id-col">
                    <a href="javascript://void(0)" @click="setSort('display_id')">
                        ID
                        <sort-icon :sort-by="sortBy" :sort-dir="sortDir" sort-value="display_id"></sort-icon>
                    </a>
                </th>
                <th>
                    <a href="javascript://void(0)" @click="setSort('title')">
                        Title
                        <sort-icon :sort-by="sortBy" :sort-dir="sortDir" sort-value="title"></sort-icon>
                    </a>
                </th>
                <th>
                    Claimed By
                </th>
                <th>
                    <a href="javascript://void(0)" @click="setSort('taskable_type')">
                        Type
                        <sort-icon :sort-by="sortBy" :sort-dir="sortDir" sort-value="taskable_type"></sort-icon>
                    </a>
                </th>
                <th>
                    Created By
                </th>
                <th class="date-icon-col">
                    <a href="javascript://void(0)" @click="setSort('due_at')">
                        Due At
                        <sort-icon :sort-by="sortBy" :sort-dir="sortDir" sort-value="due_at"></sort-icon>
                    </a>
                </th>
                <th class="date-icon-col">
                    <a href="javascript://void(0)" @click="setSort('created_at')">
                        Created At
                        <sort-icon :sort-by="sortBy" :sort-dir="sortDir" sort-value="created_at"></sort-icon>
                    </a>
                </th>
                <th class="date-icon-col">
                    <a href="javascript://void(0)" @click="setSort('completed_at')">
                        Completed At
                        <sort-icon :sort-by="sortBy" :sort-dir="sortDir" sort-value="completed_at"></sort-icon>
                    </a>
                </th>
                <th>
                    Completed By
                </th>
                <th v-if="filters.indexOf('archived') !== -1" class="date-icon-col">
                    <a href="javascript://void(0)" @click="setSort('deleted_at')">
                        Archived
                        <sort-icon :sort-by="sortBy" :sort-dir="sortDir" sort-value="deleted_at"></sort-icon>
                    </a>
                </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="task in tasks" class="pointer" v-bind:class="{success: task.completed_at}" @click="rowClick(task.id)">
                <td>
                    {{task.display_id}}
                </td>
                <td>
                    <h5>{{task.title}}</h5>
                    <h6 class="text-normal">{{task.taskable_name}}</h6>

                    <h5 v-if="task.labels.length > 0">
                        <span class="label margin-sm-right" v-for="label in task.labels"
                              :style="{'background-color': label.color}">
                            {{label.title}}
                        </span>
                    </h5>
                </td>
                <td>
                    <span class="label margin-sm-right"  v-for="access in task.accesses"
                        :style="{'background-color': '#3F900C'}">
                        {{access.user.fullName}} 
                    </span>
                </td>
                <td>
                    {{task.taskable_type_name}}
                </td>
                <td>
                    <span v-if="task.user">{{task.user.fullName}}</span>
                    <span v-else>System</span>
                </td>
                <td>
                    {{task.due_at}}
                </td>
                <td>
                    {{task.created_at.format('YYYY-MM-DD hh:mm a')}}
                </td>
                <td>
                    <span v-if="task.completed_at">{{task.completed_at}}</span>
                </td>
                <td>
                    <span v-if="task.completedBy">{{task.completedBy.fullName}}</span>
                </td>
                <td v-if="filters.indexOf('archived') !== -1">
                    <span class="label label-warning" v-if="task.deleted_at">
                        Deleted {{task.deleted_at.format('YYYY-MM-DD')}}
                    </span>
                </td>
            </tr>
            </tbody>
        </table>

        <div class="row">
            <div class="col-xs-8">
                <pagination v-model="tasksMeta.current_page" :total-page="tasksMeta.last_page"/>
            </div>
            <div class="col-xs-4 text-right">
                <span class="query-count">Count: {{tasksMeta.total}}</span>
            </div>
        </div>

        <task ref="task" :task-id="currentTaskId" :afterSave="loadTasks" @before-close="cleanupTask">
            <span></span>
        </task>
    </div>
</template>

<script>
    export default {
        props: {},
        data(){
            return {
                filters: [],
                defaultFilterOptions: [
                    {
                        label: 'Open Unassigned Callbacks',
                        value: 'open_unassigned_callbacks'
                    },
                    {
                        label: 'Show Archived',
                        value: 'archived'
                    },
                    {
                        label: 'Incomplete',
                        value: {
                            name: 'completed_at',
                            value: 'null'
                        }
                    },
                    {
                        label: 'Completed',
                        value: {
                            name: 'completed_at',
                            value: '!null'
                        }
                    },
                    {
                        label: 'My Tickets',
                        value: 'owned'
                    },
                    {
                        label: 'Assigned',
                        value: 'assigned'
                    },
                    {
                        label: 'Unassigned',
                        value: 'unassigned'
                    },
                  {
                    label: 'CSM Assignment',
                    value: 'pmticketsassigned'
                  },
                  {
                    label: 'CSM Escalation',
                    value: 'pmticketsescalation'
                  },
                  {
                    label: 'Internal User Created',
                    value: 'internallyCreated'
                  }



                ],
                taskableTypes: [
                    {
                        label: 'Calls',
                        value: 'App\\Call',
                    },
                    {
                        label: 'NetworkCredential',
                        value: 'App\\NetworkCredential',
                    },
                    {
                        label: 'Residents',
                        value: 'App\\Resident',
                    },
                    {
                        label: 'Property',
                        value: 'App\\Property',
                    },
                    {
                        label: 'User',
                        value: 'App\\User',
                    },
                    {
                        label: 'Request',
                        value: 'App\\CompensationRequest'
                    }
                ],
                taskable_type: null,
                taskable_id: null,
                currentTaskId: null,
                project_id: null,
                labelTypes: [],
                loading: true,
                properties: [],
                tasks: [],
                tasksMeta: {
                    current_page: 1,
                    last_page: 1,
                },
                sortBy: 'created_at',
                sortDir: 'DESC',
                q: null
            };
        },
        mounted(){
            this.initComponent(true);
        },
        computed: {
            filterOptions(){
                if( !_.isEmpty( this.labelTypes ) ){
                    return _.union( this.defaultFilterOptions, _.map( this.labelTypes, ( labelType ) => {
                        return {
                            label: labelType.title,
                            value: { name: 'label_type_id', value: labelType.id },
                        };
                    } ) );
                }

                return this.defaultFilterOptions;
            },

            showProperties(){
                return _.indexOf( [
                    'App\\Call',
                    'App\\Resident',
                    'App\\NetworkCredential',
                ], this.taskable_type ) !== -1;
            }
        },
        watch: {
            sortBy(){
                return this.search();
            },

            sortDir(){
                return this.search();
            },

            'tasksMeta.current_page'(){
                return this.search();
            },

            taskable_type(){
                if( !this.showProperties ){
                    this.project_id = null;
                }
            }
        },
        methods: {
            initComponent(fresh){
                var hash = location.hash;
                if( typeof hash === 'string' && hash.includes( '#task-id=' ) ){
                    var taskId = hash.replace( '#task-id=', '' );

                    this.rowClick( taskId );
                }
                if(fresh){
                this.filters  = ['owned',this.filterOptions[2].value];
                }
                return Promise.all( [
                    this.loadTasks(),
                    this.loadLabelTypes(),
                    this.loadProperties(),
                ] )
                    .catch( this.$root.handleErrors )
                    .finally( () => {
                        this.loading = false;
                    } );
            },

            loadLabelTypes(){
                return axios.get( '/api/labelTypes?sort_by=title&or[0][labelable_type]=App\\Task&or[1][labelable_type]=null' )
                    .then( ( response ) => {
                        var labelTypes = response.data.LabelTypes;

                        this.$set( this, 'labelTypes', labelTypes );
                    } );
            },

            loadTasks(){
                var url = '/api/tasks?' +
                    '_load[]=labels&_load[]=accesses&_load[]=completedBy' +
                    '&sort_by=' + this.sortBy +
                    '&sort_dir=' + this.sortDir +
                    '&page=' + this.tasksMeta.current_page + '&';

                if( this.taskable_type ){
                    url += 'taskable_type=' + this.taskable_type + '&';
                }

                if( this.taskable_id ){
                    url += 'taskable_id=' + this.taskable_id + '&';
                }

                if( this.q ){
                    url += 'q=' + this.q + '&';
                }

                if( this.project_id ){
                    url += 'project_id=' + this.project_id + '&';
                }

                _.forEach( this.filters, ( filter ) => {
                    if( _.isString( filter ) ){
                        url += filter + '=' + filter + '&';
                    }
                    else if( _.isObject( filter ) ){
                        url += filter.name + '=' + filter.value + '&';
                    }
                } );

                return axios.get( url )
                    .then( ( response ) => {
                        response.data.data = _.map( response.data.data, ( task ) => {
                            task.created_at = moment.utc( task.created_at ).local();

                            if( task.deleted_at ){
                                task.deleted_at = moment.utc( task.deleted_at ).local();
                            }

                            return task;
                        } );

                        this.$set( this, 'tasks', response.data.data );
                        this.$set( this, 'tasksMeta', response.data.meta );
                    } );
            },

            loadProperties(){
                return axios.get( '/api/properties?sort_by=name&sort_dir=asc&project_id=!null' )
                    .then( ( response ) => {
                        this.$set( this, 'properties', response.data.Properties );
                    } );
            },

            search(){
                this.loading = true;

                return this.loadTasks()
                    .catch( this.$root.handleErrors )
                    .finally( () => {
                        this.loading = false;
                    } );
            },

            rowClick( task_id ){
                this.currentTaskId = task_id;

                if( history.pushState ){
                    history.pushState( null, null, '#task-id=' + task_id );
                }
                else {
                    location.hash = '#task-id=' + task_id;
                }

                this.$nextTick( () => {
                    this.$refs.task.openModal();
                } );
            },

            cleanupTask(){
                location.hash = "";
            },

            resetFilters(){
                Object.assign( this.$data, this.$options.data() );

                this.initComponent(false);
            },

            setSort( sortBy ){
                if( this.sortBy === sortBy ){
                    this.sortDir = (this.sortDir === 'ASC' ? 'DESC' : 'ASC');
                }
                else {
                    this.sortBy = sortBy;
                    this.sortDir = 'DESC';
                }
            }
        }
    }
</script>